import { FaUser } from "react-icons/fa";
export const profileData = [
  {
    id: 1,
    name: "Aditya",
    job: "Android Developer",
    img: <FaUser style={{ fontSize: "1.7rem", color: "#fff" }} />,
  },
  {
    id: 2,
    name: "Bob D",
    job: "Python Developer",
    img: <FaUser style={{ fontSize: "1.7rem", color: "#fff" }} />,
  },
  {
    id: 3,
    name: "Susant",
    job: "Python Developer",
    img: <FaUser style={{ fontSize: "1.7rem", color: "#fff" }} />,
  },
  {
    id: 4,
    name: "Shiv",
    job: "Android Developer",
    img: <FaUser style={{ fontSize: "1.7rem", color: "#fff" }} />,
  },
  {
    id: 5,
    name: "Akash",
    job: "Android Developer",
    img: <FaUser style={{ fontSize: "1.7rem", color: "#fff" }} />,
  },
];
